import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Axiosインスタンスを作成
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// リクエストインターセプター（JWTトークンと言語パラメータを自動的に追加）
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 変更系リクエスト（POST/PUT/PATCH/DELETE）時はGETキャッシュを無効化
    const method = (config.method || 'get').toLowerCase();
    if (method !== 'get') {
      getCache.clear();
    }
    
    // 言語パラメータを追加（管理画面以外）
    const currentLang = localStorage.getItem('i18nextLng') || 'ja';
    if (!config.url?.includes('/admin') && !config.url?.includes('/auth')) {
      config.params = {
        ...config.params,
        lang: currentLang
      };
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 同一GETの多重発行を短時間キャッシュで1本に集約する。
// 初期ロードでHomePageが短時間に2回マウント（dev StrictMode / prod再マウント）し、
// 同一URLのGETが重複発行→HTTP/2で片方がabortされる問題を根本的に防ぐ。
const GET_CACHE_TTL = 4000;
const getCache = new Map(); // key -> { ts, promise }
const rawGet = api.get.bind(api);
api.get = (url, config) => {
  const lang = localStorage.getItem('i18nextLng') || 'ja';
  const paramsKey = config && config.params ? JSON.stringify(config.params) : '';
  const key = `${url}|${lang}|${paramsKey}`;
  const now = Date.now();
  const hit = getCache.get(key);
  if (hit && now - hit.ts < GET_CACHE_TTL) return hit.promise;
  const promise = rawGet(url, config).catch((e) => {
    getCache.delete(key);
    throw e;
  });
  getCache.set(key, { ts: now, promise });
  return promise;
};

// レスポンスインターセプター（401エラー時にログアウト、応答なしGETは自動リトライ）
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/admin/login';
      return Promise.reject(error);
    }
    // 応答が返らないGET（タイムアウト/ネットワーク）は最大2回まで再試行
    const config = error.config;
    const method = (config?.method || '').toLowerCase();
    if (config && method === 'get' && !error.response) {
      config.__retryCount = (config.__retryCount || 0) + 1;
      if (config.__retryCount <= 2) {
        await new Promise((r) => setTimeout(r, 500 * config.__retryCount));
        return api(config);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
